<template>
    <div>
        <form class="home-form">
            <fieldset>
                <div class="input-group">
                    <div class="input-wrapper-lg">
                        <label for="buy-now-email">Email</label>
                        <input id="buy-now-email" type="text" v-model.lazy="email" :class="validationStatus($v.email)" autocomplete="username">
                    </div>
                </div>
                <div class="error-msg" v-if="showValidationErrors && !$v.email.required">Email is required.</div>
                <div class="error-msg" v-if="showValidationErrors && $v.email.required && !$v.email.email">Email is invalid.</div>
            </fieldset>

            <fieldset>
                <div class="input-group">
                    <div class="input-wrapper-lg">
                        <label for="buy-now-password">Password</label>
                        <input id="buy-now-password" type="password" v-model="password" :class="validationStatus($v.password)" autocomplete="current-password">
                    </div>
                </div>
                <div class="error-msg" v-if="showValidationErrors && !$v.password.minLength">Password is invalid.</div>
                <div class="error-msg" v-if="showValidationErrors && !$v.password.required">Password is required.</div>
            </fieldset>

            <div class="align-center">
                <button class="btn-green-lg login-btn" type="button" @click="validate()">
                    <div v-if="loading" class="spinner">
                        &nbsp
                    </div>
                    <span v-else>
                        Log In
                    </span>
                </button>
            </div>

            <p v-if="loginError" class="error-msg-center">{{ loginError }}</p>
        </form>
    </div>
</template>

<script>
    import { validationMixin } from 'vuelidate'
    import { required, minLength, email } from 'vuelidate/lib/validators';

    export default {
        mixins: [
            validationMixin
        ],
        props: {
            loginError: String,
            loading: Boolean
        },
        data: function() {
            return  {
                email: undefined,
                password: undefined,
                showValidationErrors: false,
            }
        },
        validations: {
            email: {
                required,
                email
            },
            password: {
                required,
                minLength: minLength(6)
            }
        },
        methods: {
            validate() {
                if (!this.isFormValid() || this.loading) {
                    return;
                }

                this.submit(this.email, this.password);
            },
            isFormValid() {
                this.$v.$touch();
                this.showValidationErrors = true;
                return !this.$v.$anyError;
            },
            validationStatus(validation) {
                if (validation.$error) {
                    return 'input-error'
                }
            },
            submit() {
                this.$emit('submit', this.email, this.password);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/_variables_home.scss";
    @import "../../styles/common_home.scss";
    @import "../../styles/form_home.scss";

    fieldset {
        width: 100%;
        margin-top: 1rem;
    }
    .input-group {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
    }
    .input-wrapper {
        display: flex;
        align-items: center;
        input, select {
            width: 100%;
        }
    }
    .input-wrapper-sm {
        @extend .input-wrapper;
        width: 33%;
    }
    .input-wrapper-md {
        @extend .input-wrapper;
        width: 50%;
    }
    .input-wrapper-lg {
        @extend .input-wrapper;
        width: 100%;
        label {
            width: 150px;
        }
    }
    label {
        position: relative;
        color: #6A7C94;
        font-weight: 400;
        height: 48px;
        line-height: 48px;
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
    }
    label > span {
        width: 115px;
    }
    .field {
        box-sizing: border-box;
        border: 1px solid #CFD7DF;
        border-radius: 24px;
        outline: none;
        padding: 6px 10px;
        cursor: text;
        width: 100%;
    }
    .field::-webkit-input-placeholder {
        color: #CFD7DF;
    }
    .field::-moz-placeholder {
        color: #CFD7DF;
    }
    .field:focus, .field.StripeElement--focus {
        border-color: $green-primary;
        background-color: lighten($green-light, 15%);
    }
    .error-msg {
        margin-left: 1rem;
        color: $red-light;
        position: relative;
        top: -4px;
        text-align: left;
    }
    .error-msg-center {
        @extend .error-msg;
        text-align: center;
    }
    .input-error {
        border-color: $red-light !important;
    }
    .login-btn {
        margin: 2rem 0;
    }

    @media only screen and (max-width: $max-mobile-width) {
        .home-form label {
            font-size: 14px;
        }
    }

    @media only screen and (max-width: $max-mobile-sm-width) {
        .login-btn {
            width: 210px;
        }
    }
</style>
